import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CommuneHero = ({ selectedCommune, onExploreProperties, onStartTour }) => {
  if (!selectedCommune) {
    return (
      <div className="relative h-64 sm:h-80 lg:h-96 bg-gradient-to-br from-brand-gold to-brand-earth flex items-center justify-center px-4">
        <div className="text-center text-white max-w-2xl mx-auto">
          <Icon name="MapPin" size={40} className="mx-auto mb-3 opacity-80" />
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-heading font-display-semibold mb-2 text-white leading-tight">
            Découvrez les Communes d'Abidjan
          </h1>
          <p className="text-base sm:text-lg opacity-90">
            Explorez chaque quartier unique de notre belle ville
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative h-64 sm:h-80 lg:h-[500px] overflow-hidden">
      <Image
        src={selectedCommune?.heroImage}
        alt={`Vue panoramique de ${selectedCommune?.name}`}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 lg:p-8 text-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center space-x-2 mb-2 sm:mb-3">
            <Icon name="MapPin" size={18} />
            <span className="text-xs sm:text-sm font-medium opacity-90">Commune d'Abidjan</span>
          </div>
          
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-heading font-display-semibold mb-2 sm:mb-4 text-white leading-tight">
            {selectedCommune?.name}
          </h1>
          
          <p className="text-sm sm:text-base lg:text-xl opacity-90 max-w-3xl mb-4 sm:mb-6 text-white line-clamp-2 sm:line-clamp-none">
            {selectedCommune?.description}
          </p>
          
          <div className="flex flex-col xs:flex-row flex-wrap gap-2 sm:gap-3">
            <Button 
              variant="default" 
              size="default"
              iconName="Search"
              iconPosition="left"
              onClick={onExploreProperties}
              className="min-h-[44px] touch-manipulation"
            >
              Explorer les Propriétés
            </Button>
            
            <Button 
              variant="outline" 
              size="default"
              iconName="Eye"
              iconPosition="left"
              onClick={onStartTour}
              className="bg-white/10 backdrop-blur-sm border-white/30 text-white hover:bg-white/20 min-h-[44px] touch-manipulation"
            >
              Visite Immersive 3D
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommuneHero;